export default function slugifyName(string: string) {
  return string
    .toLowerCase()
    .replace(/(\s-\s)|(\s)|([/_~+])/g, "-")
    .replace(/[.|?,'#!$%^&*;:{}=`()\\]/g, "")
    .trim();
}
